export const showcaseSlides = [
    {
        src: '/images/showcase/car_1.JPG',
        alt: 'Mercedes-Benz G-Class',
        position: '47% 60%',
    },
    {
        src: '/images/showcase/car_2.JPG',
        alt: 'BMW X7',
        position: '43% 70%',
    },
    {
        src: '/images/showcase/car_3.jpg',
        alt: 'Mercedes-Benz G-Class on trailer',
        position: '41% 64%',
    },
    {
        src: '/images/showcase/car_4.jpg',
        alt: 'Yellow Mercedes-AMG GT',
        position: '43% 68%',
    },
    {
        src: '/images/showcase/car_5.JPG',
        alt: 'Black Mercedes-Benz G-Class',
        position: '50% 60%',
    },
    {
        src: '/images/showcase/car_6.JPG',
        alt: 'Porsche Cayenne Coupe',
        position: '49% 64%',
    },
    {
        src: '/images/showcase/car_7.JPG',
        alt: 'Mercedes-Benz G-Class in snow',
        position: '36% 68%',
    },
    {
        src: '/images/showcase/car_8.jpg',
        alt: 'Mercedes-Maybach on transporter',
        position: '46% 62%',
    },
    {
        src: '/images/showcase/car_9.jpg',
        alt: 'Mercedes-Maybach S-Class',
        position: '38% 68%',
    },
    {
        src: '/images/showcase/car_10.jpg',
        alt: 'Ferrari premium vehicle',
        position: 'center 60%',
    },
];